import React from 'react';
export function Footer() {
  return <footer className="bg-surface border-t border-surface-light py-12" data-id="element-82">
      <div className="container mx-auto px-6" data-id="element-83">
        <div className="flex flex-col items-center text-center max-w-3xl mx-auto" data-id="element-84">
          <h4 className="text-2xl font-serif text-white mb-8" data-id="element-85">
            Reinicia Tus Finanzas
          </h4>

          <div className="space-y-4 text-xs text-text-muted mb-8" data-id="element-86">
            <p data-id="element-87">
              Este sitio no es parte del sitio web de Facebook ni de Facebook
              Inc. Además, este sitio NO está respaldado por Facebook de ninguna
              manera. FACEBOOK es una marca comercial de FACEBOOK, Inc.
            </p>
            <p data-id="element-88">
              Los resultados pueden variar según la aplicación de cada usuario.
              El éxito en los negocios depende de múltiples factores.
            </p>
          </div>

          <p className="text-sm text-text-muted" data-id="element-89">
            © 2026 Reinicia Tus Finanzas. Todos los derechos reservados.
          </p>
        </div>
      </div>
    </footer>;
}